export const keySeen = '_bannerMandateSeen';
